// @flow

import moment from 'moment';
import { reconciliationStates } from '../../../../const';
import type { ReconciliationStore } from '../../../../types/shoppingCenterType';

export const getPossibleStoresList = (
  storeList: ReconciliationStore[],
  selectedStore: ReconciliationStore,
) => {
  if (selectedStore.state === reconciliationStates.MULTIPLE_LUX) {
    let possibleStoresList = storeList
      .filter(store => store.possibleLuxData
        && store.possibleLuxData.map(piv => piv.idVisioglobes).flat()
          .some(idVisioglobe => selectedStore.idVisioglobes.includes(idVisioglobe)));

    // if no store is found while matching idVisioglobes,
    // then it may be any unmapped mercury which has recently moved in
    // or a store which changed of coque
    if (possibleStoresList.length === 0) {
      possibleStoresList = storeList
        .filter(store => (store.state === reconciliationStates.MERCURY_ONLY
            || store.state === reconciliationStates.MERCURY_OK_UNMAPPED)
          && store.idMercury !== null
          && store.closingDate != null
          && moment(store.closingDate).isBetween(moment().subtract(1, 'year'), moment()));
    }
    return possibleStoresList;
  }

  const notMappedMercuryStates = [
    reconciliationStates.MERCURY_ONLY,
    reconciliationStates.MERCURY_OK_UNMAPPED,
    reconciliationStates.MULTIPLE_MERCURY,
  ]
  return storeList
    .filter(store => notMappedMercuryStates.includes(store.state));
};

export const getStoreLists = (storeList: ReconciliationStore[]) => ({
  displayedStoreList: storeList.filter(store => store.state !== reconciliationStates.HISTORY),
  historyStoreList: storeList.filter(store => store.state === reconciliationStates.HISTORY),
});

